import { call, put, all } from 'redux-saga/effects';
import { Saga } from 'custom-types/saga';

import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import {
  ExperimentsAction,
  ExperimentAnalyticsTranslation,
  AnalyticsI18nPayload,
} from 'modules/experiments/types';
import { i18nTranslations } from 'modules/experiments/ducks/actions';
import { getExperimentsTranslations } from 'modules/experiments/utils';
import { getMetricTranslationBundle } from 'utils/translations';

type ExperimentAnalyticsSaga = Saga<
  ExperimentsAction<Record<string, unknown>, AnalyticsI18nPayload>
>;

export function* setI18nTranslationSaga(): ExperimentAnalyticsSaga {
  try {
    const metricResourceBundle = yield call(getMetricTranslationBundle);

    const [
      badge,
      detailsMetadata,
      experimentType,
      tableExportLabels,
      metrics,
      notSet,
      placeholder,
    ] = yield all([
      call(getExperimentsTranslations, 'badge', {
        returnObjects: true,
      }),
      call(getExperimentsTranslations, 'detailsMetadata', {
        returnObjects: true,
      }),
      call(getExperimentsTranslations, 'experimentType', {
        returnObjects: true,
      }),
      call(getExperimentsTranslations, 'monitor.export', {
        returnObjects: true,
      }),
      call(getExperimentsTranslations, 'monitor.metrics', {
        returnObjects: true,
      }),
      call(getExperimentsTranslations, 'notSet', {
        returnObjects: true,
      }),
      call(getExperimentsTranslations, 'placeholder', {
        returnObjects: true,
      }),
    ]);

    // We mimic the experiment namespace structure out here for consistency
    // This allows the tFunctionWithSource to consume this as a source.
    const translations: ExperimentAnalyticsTranslation = {
      badge,
      detailsMetadata,
      experimentType,
      monitor: { export: tableExportLabels },
      metrics,
      notSet,
      placeholder,
    };

    yield put(i18nTranslations({ translations, metricResourceBundle }));
  } catch (error) {
    const errorMessage = yield call(getExperimentsTranslations, 'errorMessage.seti18nTranslations');

    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          errorMessage,
          source: 'setI18nTranslationSaga',
          error,
        }),
      ) as any,
    );
  }
}
